import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// Subjects (Customers)
export const getSubjects = (filters: any) => api.get(url.GET_SUBJECTS, { params: filters });
export const getSubjectsFindOne = (filters: any) => api.get(url.GET_FINDONE, { params: filters });
export const addSubject = (subject: any) => api.create(url.ADD_SUBJECT, subject);
export const updateSubject = (id: string, subject: any) => api.put(`${url.UPDATE_SUBJECT}/${id}`, subject);
export const deleteSubject = (id: string) => api.delete(`${url.DELETE_SUBJECT}/${id}`);
